/**
 * Normalizes UserTask.linkTask into a path the router can actually resolve.
 *
 * The server stores links tenant-prefixed (e.g. "/acme/employees/12"), but rows
 * created before that change are still tenant-less ("/employees/12"), and every
 * authenticated route is mounted under /:tenant. Prefixing blindly would produce
 * "/acme/acme/..." for the newer rows, so compare the first segment instead of
 * doing a substring match — a tenant name can legitimately occur inside an id.
 */
export const resolveTaskLink = (linkTask?: string | null, tenant?: string | null): string => {
  if (!linkTask) return "/";

  // Links built as absolute URLs are already complete.
  if (/^https?:\/\//i.test(linkTask)) return linkTask;

  const path = linkTask.startsWith("/") ? linkTask : `/${linkTask}`;
  if (!tenant) return path;

  const [firstSegment] = path.slice(1).split(/[/?#]/);
  return firstSegment === tenant ? path : `/${tenant}${path}`;
};
